import React, { createContext, useContext } from 'react';
import type { Ability } from './defineAbility';
import type { Perm } from './permissions';

const AbilityContext = createContext<Ability | null>(null);

export function AbilityProvider({ value, children }: { value: Ability; children: React.ReactNode }) {
  return <AbilityContext.Provider value={value}>{children}</AbilityContext.Provider>;
}

/** The only way V2 code asks "may I render". */
export function useAbility(): Ability {
  const a = useContext(AbilityContext);
  if (!a) throw new Error('useAbility must be used inside <AbilityProvider> (TierProvider supplies it).');
  return a;
}

type CanProps = { perm: Perm; children: React.ReactNode; fallback?: React.ReactNode };

export function Can({ perm, children, fallback = null }: CanProps) {
  const ability = useAbility();
  return <>{ability.can(perm) ? children : fallback}</>;
}
